import React, { useContext } from "react";
import giftIcon from "../../images/gift-icon.png";
import { Modal } from "antd";
import "./index.css";
import axios from "axios";
import { spinResultURL } from "../../Utils/apis";
import { useState } from "react";
import Confetti from "react-confetti";
import { PlayContext } from "../../App";
import { notification } from "antd";

export default function Wheel(props) {
  const { open, toggleOpen } = useContext(PlayContext);

  const [state, setState] = useState({
    selectedItem: null,
    items: [],
    prize: "",
    message: "",
    showConfetti: false,
  });

  const handleOk = () => {
    refreshPage()
  };

  function refreshPage() {
    window.location.reload(false);
  }

  const openErrorNotification = () => {
    const args = {
      message: "Error",
      description: "An Error Occoured",
      duration: 5,
    };
    notification.open(args);
  };

  const openLowBalanceNotification = () => {
    const args = {
      message: "Low Balance",
      description: "Your Balance is Low , Please Topup to make a spin",
      duration: 5,
    };
    notification.open(args);
  };

  const selectItem = () => {
    let balance = localStorage.getItem("wallet_balance");
    if (open === true && balance <= -50) {
      openLowBalanceNotification();
    } else {
      let x = 1024;
      let y = 99999;
      let selectedItem = Math.floor(Math.random() * (x - y)) + y;
      setState({
        ...state,
        selectedItem,
      });
      setTimeout(() => {
        // api call
        getSpinResult();
      }, 2000);
    }
  };

  const getSpinResult = () => {
    let get_msisdn = localStorage.getItem("msisdn");
    let get_network = localStorage.getItem("network");
    // api call
    axios({
      method: "post",
      url: spinResultURL,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        msisdn: get_msisdn,
        network: get_network,
      },
    })
      .then(function (result) {
        if (result.status === 200) {
          setState({
            ...state,
            prize: result.data.prize,
            message: result.data.message,
          });
          setTimeout(function () {
            countDown(result.data.message, result.data.prize);
          });
          // toggleOpen();  //toggle open makes the user unable to spin until he does otp verification again
        }
      })
      .catch((error) => {
        console.log(error);
        openErrorNotification();
      });
  };

  const countDown = (winMessage, winPrize) => {
    setState({
      ...state,
      showConfetti: true,
    });
    // const { message, prize } = state;
    let secondsToGo = 10;
    const modal = Modal.success({
      title: `Congratulations!!!`,
      content: `${winMessage}   You have won ${winPrize} `,
      onOk: () => handleOk(),
    });
    const timer = setInterval(() => {
      secondsToGo -= 1;
      modal.update({
        content: `${winMessage}  You have won ${winPrize} `,
      });
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      modal.destroy();
      setState({
        ...state,
        showConfetti: false,
      });
      refreshPage(); //to refresh the page for balance
    }, secondsToGo * 900);
  };

  const { selectedItem } = state;
  const { items } = props;

  const wheelVars = {
    "--nb-item": items.length,
    "--selected-item": selectedItem,
  };
  const spinning = selectedItem !== null ? "spinning" : "";

  return (
    <div style={{ minHeight: "100vh" }}>
      <div className="badge badge-primary p-2 ">
        Points : {localStorage.getItem("wallet_balance")}
      </div>
      <h2 className=" font-weight-bolder py-2" style={{ color: "#04f5ff" }}>
        Spin And Win
      </h2>
      <p className="text-dark font-weight-bold alert alert-primary">
        Each spin costs N50 the more you spin, the more your chances of winning
      </p>
      <br />
      <Confetti style={{ display: state.showConfetti ? "block" : "none" }} />
      <div className="wheel-container ">
        <div
          className={`wheel ${spinning}`}
          onClick={selectItem}
          style={wheelVars}
        >
          {items.map((item, index) => (
            <div
              className="wheel-item"
              key={index}
              style={{ "--item-nb": index }}
            >
              <p>
                {item["prize_text"]}
                <img
                  src={item["prize_image"]}
                  className="giftIcon text-primary"
                  alt="gift"
                />
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
